import React from 'react'
import styles from './styles.module.scss'
import Modal from 'srcReact/components/common2/Modal'
import { useTranslation } from 'react-i18next'
import LinkButton from 'srcReact/components/common2/LinkButton'
import Button from 'srcReact/components/common2/Button'

function MemberExceedInOrgPopin({ isOpen, closeModal, isOrgManager, goToMembersPage }) {
  const { t } = useTranslation()
  return (
    <Modal
      isOpen={isOpen}
      handleClose={closeModal}
      title={t('workplaceSettings.popin.greaterThanFreeSeats.title')}
      subTitle={
        isOrgManager
          ? t('workplaceSettings.popin.greaterThanFreeSeats.ownerText')
          : t('workplaceSettings.popin.greaterThanFreeSeats.text')
      }>
      <img className={styles.image} src={`${config.assetUrl}/images/void.svg`} alt='void' />
      <div className={styles.actions}>
        <Button
          style='secondary'
          size='large'
          text={t('workplaceSettings.popin.greaterThanFreeSeats.btnPrimary')}
          handleClick={goToMembersPage}
        />
        {isOrgManager && (
          <LinkButton
            size='large'
            text={t('workplaceSettings.popin.greaterThanFreeSeats.ownerBtnText')}
            reactLink={true}
            href='/0/pricing'
          />
        )}
      </div>
    </Modal>
  )
}

export default MemberExceedInOrgPopin
